import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExpand = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4 12L10 15.4641V8.5359L4 12ZM22 12L16 8.5359V15.4641L22 12ZM9.4 12.6H16.6V11.4H9.4V12.6Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgExpand;
